import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';

const MethodologyHero = ({ onBack }) => {
  return (
    <section className="py-16 bg-gradient-to-b from-zinc-900 to-black">
      <div className="container mx-auto px-4 lg:px-8">
        <Button 
          variant="ghost" 
          className="text-gray-400 hover:text-white mb-8"
          onClick={onBack}
        >
          <ArrowLeft className="mr-2" size={20} />
          Voltar ao Início
        </Button>
        
        <div className="text-center max-w-4xl mx-auto">
          <Badge className="bg-red-600/20 text-red-400 border-red-500/30 mb-4">
            Metodologia Justi
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Da <span className="text-blue-400">Implantação</span> à <span className="text-red-500">Implementação BIM</span>: <br className="hidden md:block" />transformando estratégia em prática
          </h1>
          <p className="text-xl text-gray-300">
            Uma abordagem estruturada e comprovada para transformar sua organização com BIM
          </p>
        </div>
      </div>
    </section>
  );
};

export default MethodologyHero;
